import { Chip, ChipProps } from '@material-ui/core';

import { useScreen } from '@/hooks/useScreen';

import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { Text } from './Text';

export const DataRowChip = ({ value, variant = 'default' }: { value: string; variant?: ChipProps['variant'] }) => {
  const { palette } = useCustomTheme();
  const { sm } = useScreen();

  return (
    <Chip
      label={<Text tId={value} />}
      variant={variant}
      style={{
        marginRight: sm ? '4px' : 0,
        marginBlock: '2.5px',
        maxWidth: '100%',
        height: '28px',
        backgroundColor: palette.grey[100],
        color: palette.text.primary,
      }}
    />
  );
};
